(function ($) {
    function mainMenu() {
        var $menuWithIcons = $('.menu--withIcons');

        $menuWithIcons.find('.navTab:first').addClass('is-active');

        $menuWithIcons.each(function(){
            var $this = $(this),
                $navTabs = $this.find('.navTab');

            $this.find('.navTab').hover(function () {
                // mouseover event codes...
                $navTabs.removeClass('is-active');
                $(this).addClass('is-active');
            }, function () {
                // mouseout event codes...
                $navTabs.removeClass('is-active');
                $this.find('.navTab:first').addClass('is-active');
            });

        });
    }

    // removeEmptyDescription
    function removeEmptyDescription() {
        var $subMenu = $('.sub-menu'),
            $empty = /s|&nbsp;/g;

        $subMenu.find('.menu-item-description').each(function(){
            var $this = $(this);

            if ($.trim($this.html())==='') {
                $this.remove();
            }
        })
    }

    mainMenu();
    removeEmptyDescription();
})(jQuery);



// Modify menu
jQuery(document).ready(function ($) {
    function expandLogin() {
        if (window.matchMedia('(max-width: 992px)').matches) {
            setTimeout(() => {
                if (!$('header .fl-menu-mobile-flyout .menu--login.fl-active').length) {
                    $('header .fl-menu-mobile-flyout .menu--login span').trigger('click');
                }
            }, 200);
        }
    }

    expandLogin();

    $(window).on('resize', function () {
        expandLogin();
    });

    $('.hamburger-menu').find('rect').attr({
        rx: 51,
        ry: 51,
        width: 550,
        height: 80,
    });
    $('.hamburger-menu').find('rect:nth-child(2)').attr({
        y: 170,
    });
    $('.hamburger-menu').find('rect:nth-child(3)').attr({
        y: 340,
    });
    $('.hamburger-menu').removeAttr('viewBox');
    $('.hamburger-menu').attr('viewBox', '0 0 550 450');
    $('.fl-menu-mobile-toggle .svg-container').attr(
        'style',
        'width: 23px!important;'
    );
});

